// extracted by mini-css-extract-plugin
export var bodyRow = "_eo-d";
export var cardColumns = "_eo-e";
export var ellipsesOverflow = "_eo-2";
export var flatBottomCorners = "_eo-3";
export var flatTopCorners = "_eo-4";
export var headerActionsDropdown = "_eo-f";
export var headerBottomRow = "_eo-c";
export var headerTopRow = "_eo-b";
export var orderDetailsWrapper = "_eo-0";
export var orderInfoContainer = "_eo-1";
export var productDetails = "_eo-9";
export var productImage = "_eo-5";
export var responsiveTable = "_eo-8";
export var shipmentContainer = "_eo-a";
export var tableBottomLeft = "_eo-6";
export var tableBottomRight = "_eo-7";